import type { CSSProperties } from 'react';

import styled, { css } from 'styled-components';

import { PaletteColor, SizeUnit } from '@utils/types';

type RowViewProps = {
  direction: 'column' | 'row';
  gap: number;
  justifyContent: CSSProperties['justifyContent'];
  alignItems: CSSProperties['alignItems'];
  marginTop?: SizeUnit;
  width?: SizeUnit | string;
  flex?: number;
  background?: PaletteColor;
  padding?: string;
  stretchChild?: boolean;
  childExtraStyle?: ReturnType<typeof css>;
};

const FlexContainer = styled.div<Partial<RowViewProps>>`
  display: flex;
  flex-direction: ${(p) => p.direction};
  justify-content: ${(p) => p.justifyContent};
  align-items: ${(p) => p.alignItems};
  margin-top: ${(p) => p.marginTop};
  padding: ${(p) => p.padding};
  gap: ${(p) => p.gap}px;
  & button[data-align-self='end'] {
    align-self: end;
    @media (max-width: 500px) {
      width: 100%;
    }
  }
  width: ${(p) => p.width};
  flex: ${(p) => p.flex};
  background: ${(p) =>
    p.background ? p.theme.palette[p.background] : 'transparent'};
  ${(p) =>
    p.stretchChild
      ? css`
          & > *:first-child {
            flex: 1;
            ${p.childExtraStyle}
          }
        `
      : null}
  position: relative;
`;

export default FlexContainer;
